import _ from "lodash";

export const getKeysOfValuesChanged = <T extends object>(object1: T, object2: T): string[] => {
  return _.union(Object.keys(object1), Object.keys(object2)).filter(
    (key) => !_.isEqual(object1[key as keyof T], object2[key as keyof T]),
  );
};
